<template>
  <div class="table-box">
    <el-button
      @click="$router.back()"
      type="text"
      class="newBackBtn"
      icon="el-icon-arrow-left"
    >
      返回
    </el-button>
    <div class="list">
      <p class="title">{{ projectName }}</p>
      <span style="color: grey; font-size: 14px;" v-if="sceneRemark">
        {{ sceneRemark }}
      </span>
      <div class="hr"></div>
      <ul>
        <li v-for="(item, index) in answerList" :key="index">
          <p style="margin-bottom: 14px;">
            {{ index + 1 }}：{{ item.title }}
            <span v-if="item.type">[{{ item | questionTypeLabelFil }}]</span>
            <span v-if="![17, 18].includes(item.type)">
              （{{ item.isMustFill === 1 ? '必填' : '非必填' }}）
            </span>
          </p>
          <div
            class="item-p"
            v-if="deal(item.answer) && ![17, 18].includes(item.type)"
          >
            无
          </div>
          <div
            class="item-p"
            v-if="item.remark"
            style="color: grey; font-size: 14px;"
          >
            备注：{{ item.remark }}
          </div>
          <div
            v-if="typeof item.answer == 'object' && item.type < 8"
            class="item-p"
          >
            <div
              v-for="(item2, index2) in item.answer"
              :key="index2 + 100"
              v-if="item.answer.length > 0"
            >
              <p v-if="item.type == 5" style="margin-bottom: 10px;">
                {{ item.manyTitleJson[index2] }}：
              </p>
              <p style="margin-bottom: 10px;">{{ item2 ? item2 : '无' }}</p>
            </div>
            <div v-else></div>
          </div>
          <div class="enclosure" v-else-if="item.type == 8">
            <template
              v-for="(item2, index2) in item.answer"
              v-if="item.answer.length > 0"
            >
              <img
                v-if="!item2.isPdf"
                v-amplifyImg="item2.url"
                :key="index2 + 100"
                :src="item2.url"
                alt
              />
              <div v-else @click="open(item2.url)" :key="index2 + 100">
                <img src="//cdn.yxvzb.com/WEB/images/pdf.jpeg" />
                <span>{{ item2.name }}</span>
              </div>
            </template>
            <div v-else></div>
          </div>
          <div
            v-else-if="fileTypeList.includes(item.type)"
            style="display: flex; flex-wrap: wrap;"
          >
            <template v-if="item.answer.length > 0">
              <div
                class="item-p"
                v-for="(item2, index2) in item.answer"
                :key="index2"
              >
                <img
                  v-amplifyImg="item2.url"
                  v-if="item.type == 13"
                  :src="item2.url"
                  alt
                  style="margin: 5px;"
                />
                <div v-else @click="open(item2.url)" :key="index2 + 100">
                  <span style="color: #409eff;">{{ item2.name }}</span>
                </div>
              </div>
            </template>
            <div v-else></div>
          </div>
          <div v-else-if="timeTypeList.includes(item.type)">
            <p class="item-p">{{ item.answer }}</p>
          </div>
          <!--图片题目-->
          <div v-else-if="item.type == 16" class="item-p">
            <img
              v-amplifyImg="item.answer.addressPicUrl"
              :src="item.answer.addressPicUrl"
              alt
              style="margin: 5px;"
              v-if="item.answer.addressPicUrl"
            />
          </div>
          <!--定位-->
          <p class="item-p" v-else-if="item.isLocation">
            <img
              v-amplifyImg="item.answer"
              :src="item.answer"
              alt
              style="margin: 5px;"
            />
          </p>
          <div v-else-if="item.type == 20" class="item-p">
            <img
              v-if="item.answer"
              v-amplifyImg="item.answer"
              :src="item.answer"
              alt
              style="margin: 5px;"
            />
          </div>
          <pre class="item-p item-pre" v-else style="line-height:1.3;">{{
            item.answer === 'null' ? '-' : item.answer
          }}</pre>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { questionType } from '@/config/staticData';
import dateFormat from '@/tools/dateFormat';

export default {
  name: 'makeSceneDetail',
  props: {
    data: {
      type: Object,
      default: {
        formData: {},
        list: []
      }
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(v) {
        let {
          makeSceneList: {
            topicList,
            makeSceneMap: {
              isSetTarget,
              isSetTime,
              isSetLocation,
              targetTitle,
              timeTitle,
              locationTitle,
              targetRemark,
              timeRemark,
              locationRemark,
              customerName,
              startDt,
              projectName,
              endDt,
              visitMinute,
              addressPicUrl,
              sceneTitle,
              sceneRemark,
              timeType,
              timeQuestions
            }
          }
        } = v;
        startDt = startDt || 0;
        endDt = endDt || 0;
        const tArr = [
          {
            title: (targetTitle || '') + '[目标题]',
            remark: targetRemark,
            answer: customerName,
            show: isSetTarget,
            isMustFill: 1
          },
          {
            title:
              (timeTitle || '') + `[时间${timeType === 1 ? '段' : '刻'}题]`,
            remark: timeRemark,
            answer: timeQuestions || '',
            show: isSetTime,
            isMustFill: 1
          },
          {
            title: (locationTitle || '') + '[定位题]',
            answer: addressPicUrl,
            remark: locationRemark,
            show: isSetLocation,
            isLocation: true,
            isMustFill: 1
          }
        ].filter(item => item.show == 1);
        this.projectName = projectName;
        this.sceneRemark = sceneRemark;
        this.answerList = tArr.concat(
          topicList.map(item => {
            if (
              item.type == 2 ||
              item.type == 5 ||
              (item.type >= 8 && item.type != 19)
            ) {
              try {
                item.answer = JSON.parse(item.answer);
              } catch (error) {}
              if (item.type == 5) {
                item.manyTitleJson = JSON.parse(item.manyTitleJson);
              }
            }
            return item;
          })
        );
      }
    }
  },
  data() {
    return {
      sceneRemark: '',
      projectName: '',
      fileTypeList: [8, 9, 10, 11, 12, 13],
      timeTypeList: [14, 15],
      list: []
    };
  },
  filters: {
    questionTypeFil(v) {
      return (questionType[v] || { label: '' }).label;
    }
  },
  methods: {
    close() {
      this.$router.back();
    },
    open(url) {
      console.log(url);
      window.open(url);
    },
    deal(v) {
      return v === null || v === '' || v.length === 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.item-pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.table-box {
  & > .list {
    text-align: left;
    font-size: 14px;
    background-color: #fff;
    border-radius: 8px;
    padding: 24px;
    & > .title {
      text-align: left;
      font-size: 20px;
      line-height: 1;
      margin-bottom: 24px;
      color: #1a1b1f;
      font-weight: 700;
    }
    & > .hr {
      width: 100%;
      height: 2px;
    }
    & > ul {
      li {
        width: 100%;
        border-bottom: 1px solid #e6e9f7;
        // margin-bottom: 30px;
        padding: 30px 0;
        padding-bottom: 20px;
        & > p {
          font-size: 14px;
          color: grey;
          line-height: 1;
          margin-bottom: 16px;
        }
        .item-p {
          font-size: 14px;
          color: black;
          line-height: 1;
          margin-bottom: 10px;
          white-space: pre-wrap;
          word-wrap: break-word;
          & > img {
            max-width: 200px;
            object-fit: cover;
          }
          &:empty {
            display: none;
          }
        }
        &:last-child {
          margin-bottom: 0;
          border-bottom: none;
        }
      }
    }
  }
}
</style>
